// Reads the non-httpOnly CSRF cookie set by the backend.
// Backend sets `boda_csrf` (cookie + header double-submit pattern per OWASP).
export function getCsrfToken() {
  if (typeof document === 'undefined' || !document.cookie) return '';
  const match = document.cookie.match(/(?:^|;\s*)boda_csrf=([^;]+)/);
  return match ? decodeURIComponent(match[1]) : '';
}
